<div data-test="Q51andf7" class="row gutters-20">
  <div data-test="vnG0eBZl" class="col-12 col-md-4 d-flex">
    <div data-test="b9eXxLDn" class="widget widget_fluid">
      <div data-test="mLGmftS1" class="widget__img">
        <svg data-test="PN26dOG7" class="icon__icon-time" width="46px" height="46px">
          <use xlink:href="#icon-time"></use>
        </svg>
      </div>
      <div data-test="HhL_Izmr" class="balance">
        <div data-test="JpAhhLpZ" class="balance__val">
          {{ statistics.total.hours }}
          <span data-test="Jizom6Km" class="balance__append balance__append_md text-dark">
            h
          </span>
          {{ pad(statistics.total.minutes) }}
        </div>
        <div data-test="RUB_2sdQ" class="balance__title text-light">
          Total action hours
        </div>
      </div>
    </div>
  </div>
  <div data-test="fRk15NTv" class="col-12 col-md-4 d-flex">
    <div data-test="eUncU7V_" class="widget widget_fluid">
      <div data-test="Pqejf0h2" class="widget__img">
        <svg
          data-test="tFcWuE_L"
          class="icon__icon-week-hours"
          width="46px"
          height="46px"
        >
          <use xlink:href="#icon-week-hours"></use>
        </svg>
      </div>
      <div data-test="gnjlogus" class="balance">
        <div data-test="W5AV70Y2" class="balance__val">
          {{ statistics.onEvent.hours }}
          <span data-test="4uN-87ZG" class="balance__append balance__append_md text-dark">
            h
          </span>
          {{ pad(statistics.onEvent.minutes) }}
        </div>
        <div data-test="ITlekmkR" class="balance__title text-light">Hours on event</div>
      </div>
    </div>
  </div>
  <div data-test="rrH8SI5e" class="col-12 col-md-4 d-flex">
    <div data-test="v8snzsEB" class="widget widget_fluid">
      <div data-test="MErLIVck" class="widget__img">
        <svg
          data-test="0v3XhJ1B"
          class="icon__icon-hours-action"
          width="46px"
          height="46px"
        >
          <use xlink:href="#icon-hours-action"></use>
        </svg>
      </div>
      <div data-test="ufQWZjrI" class="balance">
        <div data-test="3Eta-pBy" class="balance__val">
          {{ statistics.preAfterAction.hours }}
          <span data-test="Kr37Jov1" class="balance__append balance__append_md text-dark">
            h
          </span>
          {{ pad(statistics.preAfterAction.minutes) }}
        </div>
        <div data-test="-TEyqE4l" class="balance__title text-light">
          Hours pre/after action
        </div>
      </div>
    </div>
  </div>
</div>
